import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { AuthHttp } from 'angular2-jwt';

@Injectable()
export class AnnouncementService {

  constructor(private http: Http, private authHttp: AuthHttp) { }

  getAnnouncement(){
    return this.http.get('/api/announcement').map(res => res.json());
  }

  setAnnouncement(an: string){
    // console.log("set announcements: "+an);
    var announcement = {
      key: "announcement",
      value: an
    }
    // console.log(announcement);
    
    return this.authHttp.post('/api/announcement', announcement);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/announcement.service.ts